"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultErrorHandler = exports.convertError = exports.newErrorMapping = void 0;
// (C) 2007-2021 GoodData Corporation
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var http_status_codes_1 = require("http-status-codes");
var GoodDataSdkError_1 = require("./GoodDataSdkError");
var CancelablePromise_1 = require("../react/CancelablePromise");
/**
 * Returns a new, localized error code descriptors.
 *
 * @param intl - localizations
 * @returns always new instance
 * @public
 */
function newErrorMapping(intl) {
    var _a;
    var tooLargeDescriptor = {
        icon: "gd-icon-cloud-rain",
        message: intl.formatMessage({ id: "visualization.ErrorMessageDataTooLarge" }),
        description: intl.formatMessage({ id: "visualization.ErrorDescriptionDataTooLarge" }),
    };
    var genericDescriptor = {
        message: intl.formatMessage({ id: "visualization.ErrorMessageGeneric" }),
        description: intl.formatMessage({ id: "visualization.ErrorDescriptionGeneric" }),
    };
    return _a = {},
        _a[GoodDataSdkError_1.ErrorCodes.DATA_TOO_LARGE_TO_DISPLAY] = tooLargeDescriptor,
        _a[GoodDataSdkError_1.ErrorCodes.DATA_TOO_LARGE_TO_COMPUTE] = tooLargeDescriptor,
        _a[GoodDataSdkError_1.ErrorCodes.NOT_FOUND] = {
            message: intl.formatMessage({ id: "visualization.ErrorMessageNotFound" }),
            description: intl.formatMessage({ id: "visualization.ErrorDescriptionNotFound" }),
        },
        _a[GoodDataSdkError_1.ErrorCodes.UNAUTHORIZED] = {
            message: intl.formatMessage({ id: "visualization.ErrorMessageUnauthorized" }),
            description: intl.formatMessage({ id: "visualization.ErrorDescriptionUnauthorized" }),
        },
        _a[GoodDataSdkError_1.ErrorCodes.NO_DATA] = {
            icon: "gd-icon-filter",
            message: intl.formatMessage({ id: "visualization.ErrorMessageNoData" }),
            description: intl.formatMessage({ id: "visualization.ErrorDescriptionNoData" }),
        },
        _a[GoodDataSdkError_1.ErrorCodes.GEO_MAPBOX_TOKEN_MISSING] = {
            message: intl.formatMessage({ id: "visualization.ErrorDescriptionMissingMapboxToken" }),
            description: intl.formatMessage({ id: "visualization.ErrorDescriptionMissingMapboxToken" }),
        },
        _a[GoodDataSdkError_1.ErrorCodes.BAD_REQUEST] = genericDescriptor,
        _a[GoodDataSdkError_1.ErrorCodes.UNKNOWN_ERROR] = genericDescriptor,
        _a;
}
exports.newErrorMapping = newErrorMapping;
/**
 * Converts any error into an instance of {@link GoodDataSdkError}. The conversion logic right now
 * focuses mostly on errors that are contractually specified in Analytical Backend SPI. All other unexpected
 * errors are wrapped into an exception with the generic 'UNKNOWN_ERROR' code.
 *
 * Instances of GoodDataSdkError are returned as-is and are not subject to any processing.
 *
 * @param error - error to convert
 * @returns new instance of GoodDataSdkError
 * @public
 */
function convertError(error) {
    if (GoodDataSdkError_1.isGoodDataSdkError(error)) {
        return error;
    }
    else if (sdk_backend_spi_1.isAnalyticalBackendError(error)) {
        if (sdk_backend_spi_1.isUnexpectedResponseError(error)) {
            switch (error.httpStatus) {
                case http_status_codes_1.StatusCodes.NOT_FOUND:
                    return new GoodDataSdkError_1.NotFoundSdkError(GoodDataSdkError_1.ErrorCodes.NOT_FOUND, error);
                case http_status_codes_1.StatusCodes.BAD_REQUEST:
                    return new GoodDataSdkError_1.BadRequestSdkError(GoodDataSdkError_1.ErrorCodes.BAD_REQUEST, error);
                default:
                    return new GoodDataSdkError_1.UnexpectedSdkError(GoodDataSdkError_1.ErrorCodes.UNKNOWN_ERROR, error);
            }
        }
        switch (error.abeType) {
            case sdk_backend_spi_1.AnalyticalBackendErrorTypes.NO_DATA:
                return new GoodDataSdkError_1.NoDataSdkError(GoodDataSdkError_1.ErrorCodes.NO_DATA, error);
            case sdk_backend_spi_1.AnalyticalBackendErrorTypes.DATA_TOO_LARGE:
                return new GoodDataSdkError_1.DataTooLargeToComputeSdkError(GoodDataSdkError_1.ErrorCodes.DATA_TOO_LARGE_TO_COMPUTE, error);
            case sdk_backend_spi_1.AnalyticalBackendErrorTypes.PROTECTED_DATA:
                return new GoodDataSdkError_1.ProtectedReportSdkError(GoodDataSdkError_1.ErrorCodes.PROTECTED_REPORT, error);
            case sdk_backend_spi_1.AnalyticalBackendErrorTypes.NOT_AUTHENTICATED: {
                var sdkError = new GoodDataSdkError_1.UnauthorizedSdkError(GoodDataSdkError_1.ErrorCodes.UNAUTHORIZED, error);
                sdkError.authenticationFlow = error.authenticationFlow;
                return sdkError;
            }
            default:
                return new GoodDataSdkError_1.UnexpectedSdkError(GoodDataSdkError_1.ErrorCodes.UNKNOWN_ERROR, error);
        }
    }
    else if (CancelablePromise_1.isCancelError(error)) {
        return new GoodDataSdkError_1.CancelledSdkError(GoodDataSdkError_1.ErrorCodes.CANCELLED, error);
    }
    return new GoodDataSdkError_1.UnexpectedSdkError(GoodDataSdkError_1.ErrorCodes.UNKNOWN_ERROR, error);
}
exports.convertError = convertError;
/**
 * Default error handler - logs error to console as error.
 *
 * @param error - error to log
 * @public
 */
function defaultErrorHandler(error) {
    console.error(error); // eslint-disable-line no-console
}
exports.defaultErrorHandler = defaultErrorHandler;
//# sourceMappingURL=errorHandling.js.map